module.exports = __webpack_public_path__ + "img/chevron-down-black.2be3dc82.svg";